enum appEnum {
  MapImage, // 动态图层-0
  Feature, // 要素图层-1
  BuildingScene, // BIM-2
  Scene, // 场景图层-3
  Elevation, // 高程图层-4
  ImageryTile, // 图像切片图层-5
  IntegratedMesh, // 倾斜摄影-6
  Tile, // 瓦片图层-7
  WebTile, // 网络瓦片图层-8
  WMTS, // WMTS图层-9
  WMS, // WMS图层-10
  Imagery, // 图像动态图层-11
  WFS // WFS图层-12
}

export default appEnum
